import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

/**
 * Contextual Sidebar component that is used within the AppShell.
 */
export const ContextualSidebar: FC<ComponentPropsWithoutRef<'div'>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      id="contextual-sidebar"
      {...props}
      className={cn(
        `
          hidden h-[calc(100dvh-var(--top-bar-height))] min-w-(--sidebar-width)
          bg-background-surface-default
          [&:has(>div>div>*)]:block
        `,
        // Top bar mode (smaller viewports)
        `relative border-r-0`,
        // Default mode (larger viewports)
        `
          md:sticky md:top-0 md:left-0 md:border-r
          md:border-border-surface-minimal
        `,
        className
      )}
    >
      <div className="h-full max-h-full overflow-auto p-2xl">{children}</div>
    </div>
  );
};
